/**
 * @param {string|number} x
 * @param {string|number} y
 */
function resolution(x, y) {
  return `${x}x${y}`
}

module.exports = resolution
